"use strict";
/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormControl = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const atoms_1 = require("../../atoms");
const TextInput_1 = require("../../atoms/TextInput/TextInput");
const S = __importStar(require("./FormControl.styles"));
exports.FormControl = react_1.default.forwardRef((props, ref) => {
    const { label, labelHelpText, error, success, helpText, accessibilityLabel, accessibilityHint, helpTextRight, ...textInputProps } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(S.LabelContainer, null,
            react_1.default.createElement(S.StyledLabel, { accessibilityRole: "text", testID: accessibilityLabel }, label),
            labelHelpText && react_1.default.createElement(S.LabelHelpText, null, labelHelpText)),
        react_1.default.createElement(TextInput_1.TextInput, Object.assign({ ref: ref, accessibilityLabel: accessibilityLabel, accessibilityHint: accessibilityHint, error: error, success: success }, textInputProps)),
        helpText && (react_1.default.createElement(S.HelpTextContainer, null,
            react_1.default.createElement(S.HelpTextLeft, null,
                react_1.default.createElement(atoms_1.HelpText, { testID: "ErrorLabel", type: error
                        ? atoms_1.HelpTextType.ERROR
                        : success
                            ? atoms_1.HelpTextType.SUCCESS
                            : atoms_1.HelpTextType.DEFAULT }, helpText)),
            react_1.default.createElement(react_native_1.View, null, helpTextRight)))));
});
